export const tips = {
  signature: 'The digital signature of the transaction',
  transactionIndex: 'A zero-based index giving the order of the transaction in its block',
  transactionType: 'The type of transaction',
  phased: 'Phased is true if the transaction is phased, false otherwise',
  ecBlockId: 'The economic clustering block ID',
  signatureHash: 'A SHA-256 hash of the transaction signature',
  attachment: 'An object containing any additional data needed for the transaction, if applicable',
  senderRS: 'The Reed-Solomon address of the sender',
  subtype: 'The transaction subtype',
  recipientRS: 'The Reed-Solomon address of the recipient',
  block: 'The ID of the block containing the transaction',
  blockTimestamp: 'The timestamp (in seconds since the genesis block) of the block',
  deadline: 'The deadline (in minutes) for the transaction to be confirmed',
  timestamp: 'The time of the transaction creation',
  timestampUTC: 'The time (in seconds since the genesis block) of the transaction in UTC format',
  height: 'The height of the block in the blockchain',
  senderPublicKey: 'The public key of the sending account for the transaction',
  requestProcessingTime: 'The API request processing time (in millisec)',
  confirmations: 'The number of transaction confirmations',
  fullHash: 'The full hash of the signed transaction',
  version: 'The transaction version number',
  feeAPL: 'The fee of the transaction',
  amountAPL: 'The amount of the transaction',
  sender: 'The account ID of the sender',
  recipient: 'The account number of the recipient, if applicable',
  ecBlockHeight: 'The economic clustering block height',
  transaction: 'The unique transaction ID number',
  status: 'The status of the transaction',
};
